import { render, staticRenderFns } from "./explusiverecord.vue?vue&type=template&id=1da5ca17&scoped=true&"
import script from "./explusiverecord.vue?vue&type=script&lang=js&"
export * from "./explusiverecord.vue?vue&type=script&lang=js&"
import style0 from "./explusiverecord.vue?vue&type=style&index=0&id=1da5ca17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5ca17",
  null
  
)

export default component.exports